
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";

import ListAprraisal from "./ListAppraisalHR";

function ListAppraisalhrMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <ListAprraisal/>
            </BasicCard>
        </>
    )
}
export default ListAppraisalhrMain;